<template>
  <main-layout>
    <v-container>
      <h2 class="headline">{{ $t('member') }}</h2>
      <v-container fluid grid-list-md class="pa-0 ma-0 mt-3" :style="{ width: '100% !important' }">
        <v-layout wrap justify-end>
          <v-flex shrink>
            <v-btn outline color="grey" :loading="isExporting" class="ma-0" @click="exportData()">
              <v-icon>ios_share</v-icon>
              {{ $t('export') }}
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn
              color="primary"
              class="ma-0"
              @click="isAdvancedSearchVisible = !isAdvancedSearchVisible"
            >
              <v-icon>search</v-icon>
              {{ $t('advanced search') }}
              <v-icon>expand_more</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <AdvancedSearch
        v-if="isAdvancedSearchVisible"
        v-model="filters"
        @input="isAdvancedSearchVisible = false"
      />

      <MemberTable
        :items="items"
        :total="total"
        :pagination.sync="pagination"
        :loading="isLoading"
        class="mt-3"
        @changePassword="handleChangePassword"
        @edit="handleEdit"
      />
    </v-container>

    <PasswordChangeDialog
      :value="passwordChangedItem"
      :open.sync="isPasswordChangeDialogOpen"
      @success="handlePasswordChangeSuccess"
    />

    <EditFormDialog
      :value="editedItem"
      :open.sync="isEditDialogOpen"
      @success="handleEditSuccess"
    />
  </main-layout>
</template>

<script>
import tigerpolyApi from '@/api/tigerpoly'
import { mapGetters } from 'vuex'
import MemberTable from './MemberTable.vue'
import PasswordChangeDialog from './PasswordChangeDialog.vue'
import EditFormDialog from './EditFormDialog.vue'
import AdvancedSearch from './AdvancedSearch.vue'
import * as XLSX from 'xlsx'

export default {
  components: { MemberTable, PasswordChangeDialog, EditFormDialog, AdvancedSearch },
  provide() {
    return {
      positionOptions: () => this.positionOptions,
      departmentOptions: () => this.departmentOptions
    }
  },
  data() {
    return {
      items: [],
      total: 0,
      filters: {
        employee_id: '',
        username: '',
        position: null,
        department: null,
        page: 1,
        limit: 10
      },
      editedItem: null,
      passwordChangedItem: null,
      positionOptions: [],
      departmentOptions: [],
      isLoading: false,
      isAdvancedSearchVisible: false,
      isPasswordChangeDialogOpen: false,
      isEditDialogOpen: false,
      isExporting: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagination: {
      get() {
        return { page: this.filters.page, rowsPerPage: this.filters.limit }
      },
      set({ page, rowsPerPage: limit }) {
        this.filters = { ...this.filters, page, limit }
      }
    }
  },
  watch: {
    filters() {
      this.fetchItems()
    }
  },
  created() {
    this.fetchPositionOptions()
    this.fetchDepartmentOptions()
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const response = await tigerpolyApi.getMembers({
          params: {
            page_id: this.selectedBot.pageid,
            limit: this.filters.limit,
            offset: (this.filters.page - 1) * this.filters.limit,
            employee_id: this.filters.employee_id,
            username: this.filters.username,
            position: this.filters.position ? this.filters.position.value : '',
            department: this.filters.department ? this.filters.department.value : ''
          }
        })

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async fetchPositionOptions() {
      try {
        const response = await tigerpolyApi.getPositions({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 200) {
          this.positionOptions = response.data.data.map((item) => ({
            value: item.name,
            label: item.name
          }))
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchDepartmentOptions() {
      try {
        const response = await tigerpolyApi.getDepartments({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 200) {
          this.departmentOptions = response.data.data.map((item) => ({
            value: item.name,
            label: item.name
          }))
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleChangePassword(item) {
      this.passwordChangedItem = item
      this.isPasswordChangeDialogOpen = true
    },
    handleEdit(item) {
      this.editedItem = item
      this.isEditDialogOpen = true
    },
    handlePasswordChangeSuccess() {
      this.isPasswordChangeDialogOpen = false
      this.filters = { ...this.filters }
    },
    handleEditSuccess() {
      this.isEditDialogOpen = false
      this.filters = { ...this.filters }
    },
    async exportData() {
      try {
        this.isExporting = true

        const response = await tigerpolyApi.getMembers({
          params: {
            page_id: this.selectedBot.pageid,
            limit: 1000000,
            offset: 0,
            employee_id: this.filters.employee_id,
            username: this.filters.username,
            position: this.filters.position ? this.filters.position.value : '',
            department: this.filters.department ? this.filters.department.value : ''
          }
        })

        if (response.status !== 200) return

        const rows = response.data.data.map((item) => ({
          'Emp. ID': item.employee_id || '',
          'First name': item.first_name || '',
          Surname: item.last_name || '',
          Position: item.position || '',
          Department: item.department || ''
        }))

        const worksheet = XLSX.utils.json_to_sheet(rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Members')
        XLSX.writeFile(workbook, `members-${Date.now()}.xlsx`)
      } catch (error) {
        console.error(error)
      } finally {
        this.isExporting = false
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/member/Member.vue